import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideZoneChangeDetection } from '@angular/core';
import { GusoFooterComponent, provideGusoLibraryConfiguration } from 'guso-libangular';
import { gusoLibConfig } from "../config/environment";
import { PeAuthService, PeAuthTypeFactory } from '@pe-commons/authent';

const mockPeAuthService: Partial<PeAuthService> = {
    mode: PeAuthTypeFactory.MODE_INDIVIDU
};

bootstrapApplication(GusoFooterComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideGusoLibraryConfiguration(gusoLibConfig),
        { provide: PeAuthService, useValue: mockPeAuthService }
    ]
}).catch(err => console.error('Erreur bootstrap Angular:', err));
